import {
  type MutationOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';

import {
  getSummarySheetShare,
  postSummarySheetShare,
  postSummarySheetShareSendEmails,
} from '../../shared/api/magellan/summarySheet';
import type {
  CreateSummarySheetShareRequestDTO,
  CreateSummarySheetShareSendEmailsRequestDTO,
  GetSummarySheetShareDTO,
} from '../../shared/api/magellan/summarySheet/dto';

export function useSummarySheetShareMutation(
  mutationOptions: Partial<
    MutationOptions<
      { uuid: string },
      unknown,
      CreateSummarySheetShareRequestDTO
    >
  > = {},
) {
  return useMutation({
    mutationFn: async (payload: CreateSummarySheetShareRequestDTO) =>
      await postSummarySheetShare(payload),
    ...mutationOptions,
  });
}

export function useSummarySheetShareSendEmailsMutation(
  mutationOptions: Partial<
    MutationOptions<
      unknown,
      unknown,
      CreateSummarySheetShareSendEmailsRequestDTO
    >
  > = {},
) {
  return useMutation({
    mutationFn: async (payload: CreateSummarySheetShareSendEmailsRequestDTO) =>
      await postSummarySheetShareSendEmails(payload),
    ...mutationOptions,
  });
}

export function useSummarySheetShareQuery(uuid: string) {
  return useQuery<GetSummarySheetShareDTO>({
    queryKey: [getSummarySheetShare.name, uuid],
    queryFn: async () => {
      return await getSummarySheetShare(uuid);
    },
    enabled: !!uuid,
  });
}
